/* eslint-disable prettier/prettier */

import { toast } from 'react-toastify'
import withdrawServices from 'src/services/withdrawServices'
import { withdrawConstants } from '../constants/withdrawConstants'

export const withdrawAction = (headers) => (dispatch) => {
  withdrawServices
    .withdrawHistory(headers)
    .then((data) => {
      dispatch({
        type: withdrawConstants.WITHDRAW_HISTORY_API_SUCCESS,
        payload: data.data,
      })
    })
    .catch((err) => {
      dispatch({
        type: withdrawConstants.WITHDRAW_HISTORY_API_FAILED,
        payload: err,
      })
    })
}
export const withdrawCreateAction = (body, headers,setLoading) => (dispatch) => {
  withdrawServices
    .withdrawCreate(body, headers)
    .then((data) => {
      dispatch({
        type: withdrawConstants.WITHDRAW_CREATE_SUCCESS,
        payload: data.data,
      })
      if (data.status) {
        toast.success(data.message, {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
        setLoading(false)
      } else {
        toast.error('Failed to withdraw', {
          position: 'top-center',
          autoClose: 5000,
          pauseOnHover: false,
        })
        setLoading(false)
      }
    })
    .catch((err) => {
      setLoading(false)
      dispatch({
        type: withdrawConstants.WITHDRAW_CREATE_FAILED,
        payload: err,
      })
    })
}
